<div class="modal-header">
  <h4 class="modal-title">{{my_modal_title}}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
<div class="container">
<!-- <p> {{my_modal_content}}</p> -->
  <p>Por favor completa la informacion sobre quien firmara el documento, si requieres que el documento se firme con la FIEL proporciona el RFC.</p>
  <div class="form-horizontal">
    <div class="form-group">
      <div class="col-sm-2">
        <label for="signant_name" class="control-label">Nombre</label>
      </div>
      <div class="col-sm-10">
        <input class="form-control" type="text" name="signant_name" id="signant_name" [(ngModel)]="signatories.name" placeholder="Humberto Martinez">
      </div>
    </div>
    <div class="form-group">
      <div class="col-sm-2">
        <label for="signant_name" class="control-label">Email</label>
      </div>
      <div class="col-sm-10">
        <input type="email" 
        name="email_person" 
        id="signant_email" 
        class="form-control"
        [(ngModel)]="signatories.email_person" required email #emailInput="ngModel" placeholder="signer1@email.com">
        <div *ngIf="!signatories.email_person && (emailInput.dirty || emailInput.touched)">
          <div *ngIf="!signatories.email_person">Email is required.</div>
          <div *ngIf="emailInput.errors?.email">Invalid email format.</div>
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="col-sm-2">
        <label for="signant_name" class="control-label">RFC</label>
      </div>
      <div class="col-sm-10">
        <input class="form-control" type="email" name="signant_name" id="signant_name" [(ngModel)]="signatories.tax_id" placeholder="AAA010101AAA">
      </div>
      <div class="col-sm-10">
        <ngb-alert [dismissible]="false">
          <strong>Atencion!</strong> Si requieres que el documento se firme con la e.firma del SAT especifica el RFC.
        </ngb-alert>
      </div>
    </div>
  </div>    
</div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-dark" (click)="closeModalWithoutResult()">Cerrar</button>
  <div *ngIf="signatories.email_person">
    <button type="button" class="btn btn-success btn-outline-dark" (click)="closeModalWithResult()">Agregar</button>
  </div>
  <!-- <button type="button" class="btn btn-success btn-outline-dark" (click)="closeModalWithResult()">Agregar</button> -->
</div>
